//import FlightPlanningService from "coreeff-frontend/src/services/IpadPreview/BeforeTake-off/FlightPlanning.service.js";
import {createUrl} from "../../../../http";
import FlightPlanningService from "../../../../services/IpadPreview/BeforeTake-off/FlightPlanning.service"
var currentDateWithFormat = new Date().toISOString().slice(0, 10);

const state = {
    relatedFiles: [],
    jsonData: [],
    searchDate: currentDateWithFormat,
    releaseModalUrl: createUrl('/Attachment/GetFlightReleaseByFlight/'),     //  https://localhost:44333/api/Attachment/GetFlightReleaseByFlight/

    ofpModalUrl : createUrl('/LastVersion/GetLastOfpPdf/'),  // 'https://localhost:44333/api/LastVersion/GetLastOfpPdf/',     //  'https://localhost:44333/api/LastVersion/GetLastOfpPdf/'
    samplevalue : "",
};
const mutations = {
    set_json_data(state, payload) {
        state.jsonData = payload;
        state.samplevalue = "test";
    }
};
const actions = {

    async getJsonDataOfptext({commit},{FKey1,TableCode}){
        const  jsonData = await  FlightPlanningService.getJsonData(FKey1,TableCode);
        await  commit("set_json_data",jsonData);

        return  jsonData;
    },

};

const getters = {

    filteredOfpTextList : state =>
    {
            let list = [];

        for (let i = 0; i < state.jsonData.length; i++) {
            if (state.jsonData[i].LineCategory === "AtcShort") {
                list.push(state.jsonData[i].LineContext);
            }
        }

        return list;
    }

}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
